export class ValidateHelper {
  constructor(opts) {}

  // 密码校验
  password(compareField, opts: any = {}) {
    return ({ getFieldValue }) => ({
      validateTrigger: opts.validateTrigger || 'onBlur',
      validator(_, value) {
        if (!value) return Promise.reject(opts.message || '请输入新密码')
        if (
          // !/^(?=.*?[a-zA-Z])(?=.*?[0-9]).{8,12}$/g.test(value)
          !/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,16}$/g.test(value)
          // !/^[a-zA-Z0-9!@#$%^&*.~]{8,12}$/g.test(value)
        ) {
          return Promise.reject(
            // new Error(!/^.{8,16}$/g.test(value) ? '密码长须8到16位' : '密码须包含数字和大小写字母')
              new Error('8-16个字符，且必须包含大小写字母、数字')
          )
        }
        if (getFieldValue(compareField) !== value) {
          return Promise.reject(new Error('密码输入不一致'))
        }
        return Promise.resolve()
      },
    })
  }

  phoneValidate = () => ({
    validateTrigger: ['onBlur', 'onChange'],
    validator(_, value) {
      if (!value) return Promise.reject('请输入手机号')
      if (!/^[1-9]\d{10}$/.test(value)) {
        return Promise.reject('号码格式不正确')
      }
      return Promise.resolve()
    },
  })
  phoneValidateFn = (isEdit, canEdit, canView) => ({
    validateTrigger: ['onBlur', 'onChange'],
    validator(_, value) {
      if (!value) return Promise.reject('请输入手机号')
      if((isEdit && canView) || !isEdit){
       return !/^[1-9]\d{10}$/.test(value) && Promise.reject('号码格式不正确')
      } else if(isEdit && !canView) {
        if(!/^[1-9]\d{10}$/.test(value) || !/^[1-9]{1}\d{2}\*{4}\d{4}$/.test(value)){
          return Promise.reject('号码格式不正确')
        }
      }
      return Promise.resolve()
    },
  })
}

export default function useValidate(opts = {}) {
  return [new ValidateHelper(opts)]
}
